/* istanbul ignore file */
import { Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import { CREATE_EMPLOYEE_OFFER } from 'domain/shared/employee';
import { READ, UPDATE } from 'domain/shared/core/permissions';
import { GlobalProtectedRoute } from 'framework/authorization';
import EmployeeOfferContext from 'domain/people/employee/offers/EmployeeOfferContext';
import UpdateEmployeeOffer from 'domain/people/employee/offers/createupdate/Update';
import ViewEmployeeOfferPage from 'domain/people/employee/offers/Show/ViewEmployeeOfferPage';
import CreateEmployeeOfferPage from 'domain/people/employee/offers/createupdate/Create';
import { useEmployeeOfferRoute } from 'domain/people/employee/offers/employeeOfferRouting';

const EmployeeOfferRouter = () => {
  const { createRoute: createEmployeeOffer, updateRoute, singleEntityRoute } = useEmployeeOfferRoute();

  return (
    <Routes>
      <Route
        path={createEmployeeOffer}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={CREATE_EMPLOYEE_OFFER}>
            <CreateEmployeeOfferPage />
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={updateRoute}
        element={
          <EmployeeOfferContext permissionToCheck={UPDATE}>
            <UpdateEmployeeOffer />
          </EmployeeOfferContext>
        }
      />

      <Route
        path={singleEntityRoute}
        element={
          <EmployeeOfferContext permissionToCheck={READ}>
            <ViewEmployeeOfferPage />
          </EmployeeOfferContext>
        }
      />
    </Routes>
  );
};

export default EmployeeOfferRouter;
